import { errorToast, successToast } from "@/utils/constants";

type ApiMessageBody = {
  message?: string;
  detail?: string;
};

export function getApiResponseMessage(source: unknown): string {
  if (!source || typeof source !== "object") return "";

  const response = (source as { response?: { data?: ApiMessageBody } }).response;
  const body = response?.data;
  const message = body?.message?.trim() || body?.detail?.trim();
  if (message) return message;

  const direct = source as ApiMessageBody;
  if (direct.message?.trim()) return direct.message.trim();
  if (direct.detail?.trim()) return direct.detail.trim();

  return "";
}

export function getApiErrorMessage(error: unknown): string {
  const fromResponse = getApiResponseMessage(error);
  if (fromResponse) return fromResponse;

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return "";
}

/**
 * Prefer API `message`; use `fallback` only when the API returns nothing
 * (mock mode / empty body). Never invent copy when a real message exists.
 */
export function showApiSuccessToast(
  message: string | undefined,
  fallback?: string
): void {
  const text = message?.trim() || fallback?.trim();
  if (text) successToast(text, "");
}

export function showApiErrorToast(
  error: unknown,
  fallback = "Something went wrong. Please try again."
): void {
  const message = getApiErrorMessage(error) || fallback.trim();
  if (message) errorToast(message, "");
}
